import { useMemo } from 'react';

const useChairReportPermissions = ({
  isAdmin,
  isEditing,
  isReadOnly,
  isSubmitted,
  isPastDeadline,
  isChair,
}) => {
  const isEditable = useMemo(() => {
    if (isAdmin) return isEditing;
    if (isReadOnly) return false;
    if (isSubmitted) return false;
    if (isPastDeadline) return false;
    if (!isChair) return false;
    return true;
  }, [isAdmin, isEditing, isReadOnly, isSubmitted, isPastDeadline, isChair]);

  const canEdit = useMemo(() => {
    if (isAdmin) return true;
    return false;
  }, [isAdmin]);

  return { isEditable, canEdit };
};

export default useChairReportPermissions;
